import { c as _c } from "react/compiler-runtime";
import { cn } from "@/lib/utils";
interface Props {
  totals: {
    cu_earned: string;
    ai_earned: string;
    cu_max: number;
    ai_max: number;
    completion_pct: number;
  };
  totalTasks: number;
  claimedTasks: number;
  compact?: boolean;
  className?: string;
}
export function IncentiveProgress(t0) {
  const $ = _c(38);
  const {
    totals,
    totalTasks,
    claimedTasks,
    compact: t1,
    className
  } = t0;
  const compact = t1 === undefined ? false : t1;
  const clampedProgress = Math.max(0, Math.min(totals.completion_pct, 100));
  const t2 = compact ? "px-0 py-1" : "border-ds-border-default bg-ds-surface-card shadow-ds-soft rounded-xl border p-5";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("space-y-3", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="text-ds-text-primary font-semibold">Progress</span>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== claimedTasks || $[5] !== totalTasks) {
    t5 = <div className="flex items-center justify-between text-sm">{t4}<span className="text-ds-text-muted font-medium">{claimedTasks} / {totalTasks} complete</span></div>;
    $[4] = claimedTasks;
    $[5] = totalTasks;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const t6 = `${claimedTasks} of ${totalTasks} tasks complete`;
  const t7 = `${clampedProgress}%`;
  let t8;
  if ($[7] !== t7) {
    t8 = <div className="bg-ds-brand-500 shadow-ds-brand-progress-glow absolute left-0 top-0 h-full rounded-full" style={{
      width: t7
    }} />;
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] !== clampedProgress || $[10] !== t6 || $[11] !== t8) {
    t9 = <div className="bg-ds-neutral-200 dark:bg-ds-neutral-800 shadow-ds-progress-track relative h-2 w-full overflow-hidden rounded-full" role="progressbar" aria-label={t6} aria-valuenow={clampedProgress} aria-valuemin={0} aria-valuemax={100}>{t8}</div>;
    $[9] = clampedProgress;
    $[10] = t6;
    $[11] = t8;
    $[12] = t9;
  } else {
    t9 = $[12];
  }
  const t10 = compact ? "text-xs" : "text-sm";
  let t11;
  if ($[13] !== t10) {
    t11 = cn("text-ds-text-muted", t10);
    $[13] = t10;
    $[14] = t11;
  } else {
    t11 = $[14];
  }
  const t12 = Number(totals.cu_earned);
  let t13;
  if ($[15] !== t12) {
    t13 = t12.toLocaleString();
    $[15] = t12;
    $[16] = t13;
  } else {
    t13 = $[16];
  }
  let t14;
  if ($[17] !== t13) {
    t14 = <span className="text-ds-text-primary font-medium">{t13} CU</span>;
    $[17] = t13;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  const t15 = Number(totals.ai_earned);
  let t16;
  if ($[19] !== t15) {
    t16 = t15.toLocaleString();
    $[19] = t15;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== t16) {
    t17 = <span className="text-ds-text-primary font-medium">{t16} AI Credits</span>;
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== totals.cu_max) {
    t18 = totals.cu_max.toLocaleString();
    $[23] = totals.cu_max;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== totals.ai_max) {
    t19 = totals.ai_max.toLocaleString();
    $[25] = totals.ai_max;
    $[26] = t19;
  } else {
    t19 = $[26];
  }
  let t20;
  if ($[27] !== t11 || $[28] !== t14 || $[29] !== t17 || $[30] !== t18 || $[31] !== t19) {
    t20 = <p className={t11}>Earned: {t14}{" + "}{t17}{" "}of {t18} CU + {t19} AI</p>;
    $[27] = t11;
    $[28] = t14;
    $[29] = t17;
    $[30] = t18;
    $[31] = t19;
    $[32] = t20;
  } else {
    t20 = $[32];
  }
  let t21;
  if ($[33] !== t20 || $[34] !== t3 || $[35] !== t5 || $[36] !== t9) {
    t21 = <div className={t3}>{t5}{t9}{t20}</div>;
    $[33] = t20;
    $[34] = t3;
    $[35] = t5;
    $[36] = t9;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  return t21;
}